module.exports = __webpack_public_path__ + "media/images/lp/industries/i-costing-589c11316e6d2e324de25d693d256267.svg";